import React, { useEffect, useRef, useState } from 'react';
import { throttle } from 'lodash';

interface UseScrollHeaderValues {
  noTabs: boolean;
  smallHeader: boolean;
  withAnimation: boolean;
}

export const useScrollHeader = (
  headerRefObj: React.RefObject<HTMLDivElement>,
  headerHeight?: number,
  shrinkOn = 47,
): UseScrollHeaderValues => {
  const [noTabs, setNoTabs] = useState(false);
  const [smallHeader, setSmallHeader] = useState(false);
  const [withAnimation, setWithAnimation] = useState(false);
  const headerRef = useRef(headerRefObj.current);
  const headerHeightRef = useRef<number>(headerHeight || 0);

  useEffect(() => {
    headerRef.current = headerRefObj.current;
  }, [headerRefObj.current]);

  useEffect(() => {
    registerEventListener();
    return unRegisterEventListener;
  }, []);

  const registerEventListener = () => {
    window.addEventListener('scroll', throttling);
  };

  const unRegisterEventListener = () => {
    window.removeEventListener('scroll', throttling);
  };

  const throttling = throttle(() => {
    resizeHeader();
  }, 20);

  const resizeHeader = () => {
    const node: HTMLDivElement | null = headerRef.current;
    // Don't use scrollY because of IE
    const distanceY = window.pageYOffset;
    if (node) {
      if (!headerHeightRef.current) {
        headerHeightRef.current = headerHeight || node.offsetHeight;
      }
      if (node.style && headerHeightRef.current - distanceY < 0) {
        node.style.height = '0';
      } else {
        node.style.height = `${headerHeightRef.current - distanceY}px`;
      }
      if (distanceY > 180) {
        if (!noTabs) {
          setNoTabs(true);
        }
      } else if (noTabs) {
        setNoTabs(false);
      }
      if (distanceY > shrinkOn) {
        if (!smallHeader) {
          if (!withAnimation) {
            setWithAnimation(true);
          }
          setSmallHeader(true);
        }
      } else {
        setSmallHeader(false);
        setNoTabs(false);
      }
    }
  };
  return { smallHeader, noTabs, withAnimation };
};
